const { Record } = require('immutable')

export default Record({
    error: null,
    isFetching: false,
    shouldReload: true,
    dataSource: Record({
        data: [],
        pagination: Record({
            page: 1,
            size: 15,
            totalCount: 0
        })(),
        filter: Record({
            name: ''
        })()
    })()
})